import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../util/utils';

import {IconoirMail} from '@ey-xd/motif-icon';

import Button from '../../CoreWrappers/Button';
import EngagementUsersDropdown from '../EngagementUsersDropdown';

const ReconciliationsGenerateMail = ({engagementId}) => {
	const renderTrigger = () => {
		const props = {
			variant: 'text-alt',
			label: labels.generateEmail,
			size: 'medium',
			svg: IconoirMail
		};

		return <Button {...props} />;
	};

	const props = {
		renderTrigger,
		engagementId
	};

	return <EngagementUsersDropdown {...props} />;
};

ReconciliationsGenerateMail.propTypes = {
	engagementId: PropTypes.string
};

export default ReconciliationsGenerateMail;
